import ae, { memo as at, useState as P, useReducer as rt, useCallback as Z, useEffect as F, useContext as k, useMemo as re, createContext as it } from "react";
import { useNavigate as $, useLocation as ot, Routes as $e, Route as w } from "react-router-dom";
import { FormElement as _e, ConfirmationDialog as je, SpinnerWidgetContainer as Ue, FavoritesHeader as ct, HomePageWidgetList as lt, HomePageWidgetListItem as pe, ModuleDescriptionCard as ut, TabWithCounter as se, ICON_COLUMN as dt, NAME_COLUMN as mt, DATE_COLUMN as ft, UPDATED_COLUMN as gt, AUTHOR_COLUMN as pt, EntityTypeCell as he, NameCell as be, PageList as St, AuthorCell as ht, DateCell as Ge, BaseContentWrapper as bt, BaseInfoWrapper as Ct, ListHeaderPrimary as yt, TabsNavigationNew as Et, BaseEntityContent as xt, useIsLibraryDataSteward as It } from "@prometheus/features";
import { useNotifications as ie, Grid as j, Block as Tt, Input as Rt, Button as M, Spinner as Ce, Icon as Q, EmptyTableStub as ve, Tooltip as _t, Box as jt, useTheme as Ye, StatusTag as Be, NewTable as qe } from "@prometheus/components";
import { Status as b } from "@prometheus/types";
import { api as y, getSortDirection as vt, getReducerWithProduce as At, getUUID as Ae, createSortingMethodListConfig as Nt, createHeadersFromMetadataAttributes as Ot, createFiltersPanelListConfig as wt, createCrudMethodsListConfig as Ft, getInvitationColorModel as He, setErrorHandlingNotifications as Pt } from "@prometheus/utils";
import { EntityTypes as h, InvitationStatus as We, EntityTypeLabel as Lt, ENTITY_TYPES as N, EntityType as zt, invitationTypes as Ke, TypesOfContainer as H } from "@prometheus/enums";
import { ModalContext as Mt, DialogContext as kt, useRequest as Dt } from "@prometheus/hooks";
import { setBreadcrumbs as Ve } from "@prometheus/redux";
import { useDispatch as Je } from "react-redux";
var Se = { exports: {} }, J = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ne;
function $t() {
  if (Ne) return J;
  Ne = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.fragment");
  function n(a, i, c) {
    var u = null;
    if (c !== void 0 && (u = "" + c), i.key !== void 0 && (u = "" + i.key), "key" in i) {
      c = {};
      for (var g in i)
        g !== "key" && (c[g] = i[g]);
    } else c = i;
    return i = c.ref, {
      $$typeof: e,
      type: a,
      key: u,
      ref: i !== void 0 ? i : null,
      props: c
    };
  }
  return J.Fragment = t, J.jsx = n, J.jsxs = n, J;
}
var X = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Oe;
function Ut() {
  return Oe || (Oe = 1, process.env.NODE_ENV !== "production" && function() {
    function e(r) {
      if (r == null) return null;
      if (typeof r == "function")
        return r.$$typeof === ue ? null : r.displayName || r.name || null;
      if (typeof r == "string") return r;
      switch (r) {
        case x:
          return "Fragment";
        case U:
          return "Profiler";
        case A:
          return "StrictMode";
        case Y:
          return "Suspense";
        case ce:
          return "SuspenseList";
        case le:
          return "Activity";
      }
      if (typeof r == "object")
        switch (typeof r.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), r.$$typeof) {
          case E:
            return "Portal";
          case T:
            return (r.displayName || "Context") + ".Provider";
          case G:
            return (r._context.displayName || "Context") + ".Consumer";
          case v:
            var f = r.render;
            return r = r.displayName, r || (r = f.displayName || f.name || "", r = r !== "" ? "ForwardRef(" + r + ")" : "ForwardRef"), r;
          case V:
            return f = r.displayName || null, f !== null ? f : e(r.type) || "Memo";
          case ee:
            f = r._payload, r = r._init;
            try {
              return e(r(f));
            } catch {
            }
        }
      return null;
    }
    function t(r) {
      return "" + r;
    }
    function n(r) {
      try {
        t(r);
        var f = !1;
      } catch {
        f = !0;
      }
      if (f) {
        f = console;
        var C = f.error, R = typeof Symbol == "function" && Symbol.toStringTag && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return C.call(
          f,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          R
        ), t(r);
      }
    }
    function a(r) {
      if (r === x) return "<>";
      if (typeof r == "object" && r !== null && r.$$typeof === ee)
        return "<...>";
      try {
        var f = e(r);
        return f ? "<" + f + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function i() {
      var r = B.A;
      return r === null ? null : r.getOwner();
    }
    function c() {
      return Error("react-stack-top-frame");
    }
    function u(r) {
      if (te.call(r, "key")) {
        var f = Object.getOwnPropertyDescriptor(r, "key").get;
        if (f && f.isReactWarning) return !1;
      }
      return r.key !== void 0;
    }
    function g(r, f) {
      function C() {
        L || (L = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          f
        ));
      }
      C.isReactWarning = !0, Object.defineProperty(r, "key", {
        get: C,
        configurable: !0
      });
    }
    function d() {
      var r = e(this.type);
      return ne[r] || (ne[r] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), r = this.props.ref, r !== void 0 ? r : null;
    }
    function l(r, f, C, R, z, O, me, fe) {
      return C = O.ref, r = {
        $$typeof: o,
        type: r,
        key: f,
        props: O,
        _owner: z
      }, (C !== void 0 ? C : null) !== null ? Object.defineProperty(r, "ref", {
        enumerable: !1,
        get: d
      }) : Object.defineProperty(r, "ref", { enumerable: !1, value: null }), r._store = {}, Object.defineProperty(r._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(r, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(r, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: me
      }), Object.defineProperty(r, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: fe
      }), Object.freeze && (Object.freeze(r.props), Object.freeze(r)), r;
    }
    function p(r, f, C, R, z, O, me, fe) {
      var _ = f.children;
      if (_ !== void 0)
        if (R)
          if (de(_)) {
            for (R = 0; R < _.length; R++)
              m(_[R]);
            Object.freeze && Object.freeze(_);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else m(_);
      if (te.call(f, "key")) {
        _ = e(r);
        var q = Object.keys(f).filter(function(st) {
          return st !== "key";
        });
        R = 0 < q.length ? "{key: someKey, " + q.join(": ..., ") + ": ...}" : "{key: someKey}", Re[_ + R] || (q = 0 < q.length ? "{" + q.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          R,
          _,
          q,
          _
        ), Re[_ + R] = !0);
      }
      if (_ = null, C !== void 0 && (n(C), _ = "" + C), u(f) && (n(f.key), _ = "" + f.key), "key" in f) {
        C = {};
        for (var ge in f)
          ge !== "key" && (C[ge] = f[ge]);
      } else C = f;
      return _ && g(
        C,
        typeof r == "function" ? r.displayName || r.name || "Unknown" : r
      ), l(
        r,
        _,
        O,
        z,
        i(),
        C,
        me,
        fe
      );
    }
    function m(r) {
      typeof r == "object" && r !== null && r.$$typeof === o && r._store && (r._store.validated = 1);
    }
    var S = ae, o = Symbol.for("react.transitional.element"), E = Symbol.for("react.portal"), x = Symbol.for("react.fragment"), A = Symbol.for("react.strict_mode"), U = Symbol.for("react.profiler"), G = Symbol.for("react.consumer"), T = Symbol.for("react.context"), v = Symbol.for("react.forward_ref"), Y = Symbol.for("react.suspense"), ce = Symbol.for("react.suspense_list"), V = Symbol.for("react.memo"), ee = Symbol.for("react.lazy"), le = Symbol.for("react.activity"), ue = Symbol.for("react.client.reference"), B = S.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, te = Object.prototype.hasOwnProperty, de = Array.isArray, I = console.createTask ? console.createTask : function() {
      return null;
    };
    S = {
      react_stack_bottom_frame: function(r) {
        return r();
      }
    };
    var L, ne = {}, Ie = S.react_stack_bottom_frame.bind(
      S,
      c
    )(), Te = I(a(c)), Re = {};
    X.Fragment = x, X.jsx = function(r, f, C, R, z) {
      var O = 1e4 > B.recentlyCreatedOwnerStacks++;
      return p(
        r,
        f,
        C,
        !1,
        R,
        z,
        O ? Error("react-stack-top-frame") : Ie,
        O ? I(a(r)) : Te
      );
    }, X.jsxs = function(r, f, C, R, z) {
      var O = 1e4 > B.recentlyCreatedOwnerStacks++;
      return p(
        r,
        f,
        C,
        !0,
        R,
        z,
        O ? Error("react-stack-top-frame") : Ie,
        O ? I(a(r)) : Te
      );
    };
  }()), X;
}
process.env.NODE_ENV === "production" ? Se.exports = $t() : Se.exports = Ut();
var s = Se.exports;
const Gt = at((e) => {
  const { onClose: t, item: n, inviteMethod: a, typeEntity: i, id: c, name: u, type: g } = e, [d, l] = P(b.INITIAL), [p, m] = P(), { enqueueSnackbar: S } = ie(), o = async () => {
    l(b.IN_PROGRESS);
    try {
      await a(p, () => {
        l(b.SUCCESS);
      });
    } catch {
      l(b.ERROR);
    }
  };
  return /* @__PURE__ */ s.jsx(j, { container: !0, children: /* @__PURE__ */ s.jsx(Tt, { children: /* @__PURE__ */ s.jsxs(j, { container: !0, spacing: 2, p: 2, children: [
    /* @__PURE__ */ s.jsx(j, { item: !0, xs: 12, children: /* @__PURE__ */ s.jsxs(_e, { children: [
      g === "INCOMING" ? "Reject" : "Cancel",
      " publishing",
      " ",
      /* @__PURE__ */ s.jsx("b", { children: u }),
      " for reason:"
    ] }) }),
    /* @__PURE__ */ s.jsx(j, { item: !0, xs: 12, children: /* @__PURE__ */ s.jsx(_e, { name: "message", textLabel: "Response Message", children: /* @__PURE__ */ s.jsx(
      Rt,
      {
        type: "text",
        value: p || "",
        minRows: 2,
        maxRows: 4,
        multiline: !0,
        size: "medium",
        onChange: (E) => m(E.target.value),
        fullWidth: !0,
        name: "message"
      }
    ) }) }),
    /* @__PURE__ */ s.jsxs(j, { item: !0, xs: 12, textAlign: "right", children: [
      /* @__PURE__ */ s.jsx(
        M,
        {
          variant: "outlined",
          onClick: t,
          disabled: d === b.IN_PROGRESS,
          name: "delete",
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ s.jsx(
        M,
        {
          onClick: o,
          variant: "contained",
          color: "error",
          name: "save",
          disabled: d === b.IN_PROGRESS,
          sx: { ml: 1 },
          startIcon: d === b.IN_PROGRESS ? /* @__PURE__ */ s.jsx(Ce, { size: 16 }) : /* @__PURE__ */ s.jsx(Q, { iconName: "deactivate" }),
          children: g === "INCOMING" ? "Reject publishing" : "Cancel"
        }
      )
    ] })
  ] }) }) });
});
var W = /* @__PURE__ */ ((e) => (e.LIBRARY = "library", e.INCOMING = "incoming", e.OUTGOING = "outgoing", e))(W || {});
const Xe = (e, t) => {
  const { pageNumber: n, pageSize: a, sortBy: i, query: c } = t, u = vt(i);
  return `${e}?size=${a || ""}&page=${n || 0}&sort=${u}&${c || ""}`;
}, Yt = async (e, t) => {
  var a;
  let n = null;
  for (const i of e)
    try {
      return await y.get(Xe(i, t));
    } catch (c) {
      n = c;
      const u = (a = c == null ? void 0 : c.response) == null ? void 0 : a.status;
      if (![400, 403, 404, 405].includes(u))
        throw c;
    }
  throw n;
}, Ze = (e) => y.get(Xe("/library/list", e)), Bt = () => y.get("/library/sorts"), qt = (e) => {
  const t = `/library/filter?${e}`;
  return y.get(t);
}, Ht = () => y.get("/library/cohort/invites/incoming"), Wt = () => y.get("/library/cohort/invites/outgoing"), Kt = (e) => y.post(`/library/cohort/invites/${e}/accept`), Vt = (e, t) => y.post(`/library/cohort/invites/${e}/dismiss`, t), Jt = () => y.get("/library/custom-code/invites/incoming"), Xt = () => y.get("/library/custom-code/invites/outgoing"), Zt = (e) => y.post(`/library/custom-code/invites/${e}/accept`), Qt = (e, t) => y.post(`/library/custom-code/invites/${e}/dismiss`, t), en = () => y.get("/library/concept-set/invites/incoming"), tn = () => y.get("/library/concept-set/invites/outgoing"), nn = (e) => y.post(`/library/concept-set/invites/${e}/accept`), sn = (e, t) => y.post(`/library/concept-set/invites/${e}/dismiss`, t), ye = () => y.get("/library/summary"), we = async () => {
  var t;
  const e = await Yt(["/draft-features/list"], {
    pageNumber: 0,
    pageSize: 1,
    sortBy: { id: "modified.timestamp", desc: !0 },
    query: ""
  });
  return Number(
    (e == null ? void 0 : e.totalElements) ?? (e == null ? void 0 : e.numberOfElements) ?? ((t = e == null ? void 0 : e.content) == null ? void 0 : t.length) ?? 0
  );
}, oe = "/library/feature-analyses/invites", an = () => y.get(`${oe}/incoming`), rn = () => y.get(`${oe}/outgoing`), on = (e) => y.post(`${oe}/${e}/accept`), cn = (e, t) => y.post(`${oe}/${e}/dismiss`, t);
var D = /* @__PURE__ */ ((e) => (e.ACCEPT_SUCCESS = "ACCEPT_SUCCESS", e.DISMISS_SUCCESS = "DISMISS_SUCCESS", e))(D || {});
const ln = {
  list: [],
  status: b.INITIAL,
  forceReload: null,
  error: null,
  notifyMessage: null
}, Fe = (e) => Array.isArray(e) ? e : (e == null ? void 0 : e.data) ?? [], un = (e, t) => At(e, (n) => {
  switch (t.type) {
    case "GET_LIST":
      n.status = b.IN_PROGRESS, n.list = [], n.error = null;
      break;
    case "ACCEPT_DONE":
      n.status = "ACCEPT_SUCCESS", n.forceReload = Ae(), n.notifyMessage = `Request to publish ${t.payload} successfully approved`, n.error = null;
      break;
    case "DISMISS_DONE":
      n.status = "DISMISS_SUCCESS", n.forceReload = Ae(), n.notifyMessage = `Request to publish ${t.payload} declined`, n.error = null;
      break;
    case "GET_LIST_DONE":
      n.list = t.payload, n.status = b.SUCCESS;
      break;
    case "GET_LIST_FAILED":
    case "ACCEPT_FAILED":
    case "DISMISS_FAILED":
      n.list = [], n.status = b.ERROR, n.error = t.payload;
      break;
  }
}), Ee = (e, t = !1) => {
  const [n, a] = rt(un, ln), i = Z(async () => {
    a({
      type: "GET_LIST"
      /* GET_LIST */
    });
    try {
      const d = await Ht(), l = await en(), p = await Jt(), m = Fe(
        await an().catch(() => [])
      ), S = [
        ...d.map((o) => ({ ...o, typeEntity: h.COHORT })),
        ...l.map((o) => ({ ...o, typeEntity: h.CONCEPT_SET })),
        ...p.map((o) => ({
          ...o,
          typeEntity: h.CUSTOM_CODE,
          subject: { ...o.subject, name: o == null ? void 0 : o.subject.title }
        })),
        ...m.map((o) => {
          var E, x;
          return {
            ...o,
            typeEntity: h.FEATURE_ANALYSIS,
            subject: {
              ...o.subject,
              name: ((E = o == null ? void 0 : o.subject) == null ? void 0 : E.name) || ((x = o == null ? void 0 : o.subject) == null ? void 0 : x.title)
            }
          };
        })
      ];
      a({
        type: "GET_LIST_DONE",
        payload: S
      });
    } catch (d) {
      a({
        type: "GET_LIST_FAILED",
        payload: d
      });
    }
  }, []), c = Z(async () => {
    a({
      type: "GET_LIST"
      /* GET_LIST */
    });
    try {
      const d = await Wt(), l = await tn(), p = await Xt(), m = Fe(
        await rn().catch(() => [])
      ), S = [
        ...d.map((o) => ({ ...o, typeEntity: h.COHORT })),
        ...l.map((o) => ({ ...o, typeEntity: h.CONCEPT_SET })),
        ...p.map((o) => ({
          ...o,
          typeEntity: h.CUSTOM_CODE,
          subject: { ...o.subject, name: o == null ? void 0 : o.subject.title }
        })),
        ...m.map((o) => {
          var E, x;
          return {
            ...o,
            typeEntity: h.FEATURE_ANALYSIS,
            subject: {
              ...o.subject,
              name: ((E = o == null ? void 0 : o.subject) == null ? void 0 : E.name) || ((x = o == null ? void 0 : o.subject) == null ? void 0 : x.title)
            }
          };
        })
      ];
      a({
        type: "GET_LIST_DONE",
        payload: S
      });
    } catch (d) {
      a({
        type: "GET_LIST_FAILED",
        payload: d
      });
    }
  }, []), u = Z(
    async (d, l, p) => {
      a({
        type: "ACCEPT"
        /* ACCEPT */
      });
      try {
        switch (d) {
          case h.COHORT:
            await Kt(l);
            break;
          case h.CONCEPT_SET:
            await nn(l);
            break;
          case h.CUSTOM_CODE:
            await Zt(l);
            break;
          case h.FEATURE_ANALYSIS:
            await on(l);
            break;
        }
        a({
          type: "ACCEPT_DONE",
          payload: p
        });
      } catch (m) {
        a({
          type: "ACCEPT_FAILED",
          payload: m
        });
      }
    },
    []
  ), g = Z(
    async (d, l, p, m) => {
      a({
        type: "DISMISS"
        /* DISMISS */
      });
      try {
        switch (d) {
          case h.COHORT:
            await Vt(l, { note: p || "" });
            break;
          case h.CONCEPT_SET:
            await sn(l, { note: p || "" });
            break;
          case h.CUSTOM_CODE:
            await Qt(l, { note: p || "" });
            break;
          case h.FEATURE_ANALYSIS:
            await cn(l, { note: p || "" });
            break;
        }
        a({
          type: "DISMISS_DONE",
          payload: m
        });
      } catch (S) {
        a({
          type: "DISMISS_FAILED",
          payload: S
        });
      }
    },
    []
  );
  return F(() => {
    if (!t)
      switch (e) {
        case W.INCOMING:
          i();
          break;
        case W.OUTGOING:
          c();
      }
  }, [e, n.forceReload]), {
    ...n,
    getIncomes: i,
    acceptInvitation: u,
    dismissInvitation: g
  };
}, dn = (e) => {
  var t;
  return e === h.FEATURE_ANALYSIS ? "custom feature" : Lt[e] || ((t = N[e]) == null ? void 0 : t.name) || "";
}, xe = (e) => {
  const {
    id: t,
    type: n,
    name: a,
    typeEntity: i,
    accept: c,
    dismiss: u,
    textAccept: g = "Accept",
    textDismiss: d,
    isRedirect: l = !1,
    requestStatus: p
  } = e, m = d || (n === "OUTGOING" ? "Cancel" : "Reject"), S = !p || p === We.PENDING, { openModal: o, closeModal: E } = k(Mt), [x, A] = P(!1), { showDialog: U, hideDialog: G } = k(kt), T = $(), { enqueueSnackbar: v } = ie(), { acceptInvitation: Y, dismissInvitation: ce, status: V, notifyMessage: ee } = Ee(W.LIBRARY, !0), le = () => {
    U(je, {
      onSubmit: async () => {
        A(!0), c ? await c(i, t, a) : await te(), A(!1);
      },
      onClose: G,
      text: `Please confirm approval to publish ${dn(
        i
      )} ${a} to the library`,
      confirmButtonText: "Approve",
      variant: "success"
    });
  }, ue = (I, L) => {
    U(je, {
      onSubmit: async () => {
        A(!0), u ? await u(i, t, I, a) : await de(I), A(!1), E();
      },
      onDecline: () => {
        L == null || L();
      },
      onClose: G,
      text: `Please confirm ${m.toLowerCase()} to publish ${zt[i]} ${a} in the library`,
      confirmButtonText: "Confirm"
    });
  }, B = () => {
    var I;
    o(
      () => /* @__PURE__ */ s.jsx(
        Gt,
        {
          name: a,
          inviteMethod: (L, ne) => {
            ue(L, ne);
          },
          onClose: E,
          typeEntity: i,
          type: n,
          id: t
        }
      ),
      `${m} publishing ${(I = N[i]) == null ? void 0 : I.name}`,
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: E
      }
    );
  }, te = async () => {
    await Y(i, t, a);
  }, de = async (I) => {
    await ce(i, t, I, a);
  };
  return F(() => {
    (V === D.ACCEPT_SUCCESS || V === D.DISMISS_SUCCESS) && (v({
      message: ee,
      variant: "success"
    }), l && T("/library"));
  }, [V]), /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    n === "INCOMING" && S && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx(
        M,
        {
          size: "small",
          color: "success",
          variant: "contained",
          disabled: x,
          startIcon: /* @__PURE__ */ s.jsx(Q, { iconName: "submit" }),
          onClick: (I) => {
            I.stopPropagation(), le();
          },
          children: g
        }
      ),
      /* @__PURE__ */ s.jsx(
        M,
        {
          sx: { ml: 1 },
          size: "small",
          variant: "contained",
          color: "error",
          disabled: x,
          startIcon: /* @__PURE__ */ s.jsx(Q, { iconName: "deactivate" }),
          onClick: (I) => {
            I.stopPropagation(), B();
          },
          children: m
        }
      )
    ] }),
    n === "OUTGOING" && S && /* @__PURE__ */ s.jsx(s.Fragment, { children: /* @__PURE__ */ s.jsx(
      M,
      {
        sx: { ml: 1 },
        size: l ? "medium" : "small",
        variant: "contained",
        color: "error",
        disabled: x,
        startIcon: /* @__PURE__ */ s.jsx(Q, { iconName: "deactivate" }),
        onClick: (I) => {
          I.stopPropagation(), B();
        },
        children: m
      }
    ) })
  ] });
}, mn = {
  title: "Artifacts Library",
  url: "/library",
  description: "Artifacts Library is a governed collection of standardized artifacts, including concept sets and cohorts that can be imported and used as templates in studies. Re-use existing artifacts or publish new artifacts into the library to be re-used by others.",
  titleButton: "Go to library"
}, fn = (e) => {
  const t = Z((d) => Ze({
    pageNumber: 0,
    pageSize: 10,
    sortBy: { id: "published", desc: !0 }
  }), []), n = $(), { status: a, state: i } = Dt(t), [c, u] = P(!1), g = () => {
    u(!c);
  };
  return a === b.INITIAL || a === b.IN_PROGRESS ? /* @__PURE__ */ s.jsx(Ue, { children: /* @__PURE__ */ s.jsx(Ce, { size: 32 }) }) : /* @__PURE__ */ s.jsxs(j, { container: !0, children: [
    /* @__PURE__ */ s.jsx(j, { item: !0, xs: 12, children: /* @__PURE__ */ s.jsx(ct, { children: "Recent Artifacts" }) }),
    /* @__PURE__ */ s.jsxs(lt, { children: [
      a === b.SUCCESS && (i != null && i.content.length ? i.content.slice(0, Math.min(i.content.length, c ? 10 : 5)).map((d) => {
        var p, m, S;
        const l = d.type;
        return /* @__PURE__ */ s.jsx(
          pe,
          {
            onClick: () => {
              l === h.CONCEPT_SET && n(`/library/concept-sets/${d.id}`), l === h.COHORT && n(`/library/cohorts/${d.id}`), l === h.FEATURE_ANALYSIS && n(`/library/feature-analyses/${d.id}`), l === h.CUSTOM_CODE && n(`/library/custom-code/${d.id}`);
            },
            children: /* @__PURE__ */ s.jsxs(
              "div",
              {
                className: "list-item-section nowrap",
                title: (p = N[l]) == null ? void 0 : p.name,
                children: [
                  /* @__PURE__ */ s.jsx(
                    Q,
                    {
                      iconName: (m = N[l]) == null ? void 0 : m.iconName,
                      sx: {
                        color: (S = N[l]) == null ? void 0 : S.color
                      }
                    }
                  ),
                  /* @__PURE__ */ s.jsx("div", { className: "list-item-title", title: d.name, children: d.name })
                ]
              }
            )
          },
          d.id + "-recent-artifact"
        );
      }) : /* @__PURE__ */ s.jsx(pe, { light: !0, children: /* @__PURE__ */ s.jsx(ve, { noDataText: "No recent artifacts found", dark: !0 }) })),
      a === b.ERROR && /* @__PURE__ */ s.jsx(pe, { light: !0, children: /* @__PURE__ */ s.jsx(
        ve,
        {
          noDataText: "Failed to load recent artifacts",
          addButtonText: ""
        }
      ) })
    ] }),
    (i == null ? void 0 : i.content.length) > 5 && /* @__PURE__ */ s.jsx(j, { container: !0, justifyContent: "flex-end", mt: 2, children: /* @__PURE__ */ s.jsx(M, { onClick: g, size: "small", variant: "text", color: "info", children: c ? "Show less" : "Show more..." }) })
  ] });
}, gn = (e) => {
  const { name: t, config: n, ...a } = e, i = $(), { title: c, url: u, description: g, titleButton: d } = mn, {
    onAccept: l,
    onDismiss: p,
    typeEntity: m,
    nameEntity: S,
    type: o,
    id: E,
    isRedirect: x,
    requestStatus: A
  } = n;
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    t === "answer-publish-widget" && /* @__PURE__ */ s.jsx(
      xe,
      {
        ...a,
        type: o,
        typeEntity: m,
        name: S,
        id: E,
        accept: l,
        dismiss: p,
        isRedirect: x,
        requestStatus: A
      }
    ),
    t === "home-widget" && /* @__PURE__ */ s.jsx(
      ut,
      {
        title: c,
        onClick: () => i(u),
        description: g,
        iconName: "library",
        actions: /* @__PURE__ */ s.jsx(s.Fragment, { children: /* @__PURE__ */ s.jsx(
          M,
          {
            onClick: () => i(u),
            variant: "outlined",
            name: "save",
            children: d
          }
        ) }),
        children: /* @__PURE__ */ s.jsx(j, { item: !0, xs: 12, container: !0, pt: 2, children: /* @__PURE__ */ s.jsx(fn, {}) })
      }
    )
  ] });
}, pn = {
  entityNavigationPanel: (e = !1, t, n, a = !1) => {
    const i = [
      {
        value: "",
        title: /* @__PURE__ */ s.jsx(
          se,
          {
            title: "Artifacts library",
            count: (t == null ? void 0 : t.items) || 0,
            status: b.SUCCESS
          }
        ),
        end: !0
      }
    ];
    return e && i.push({
      value: "incoming",
      title: /* @__PURE__ */ s.jsx(
        se,
        {
          title: "Publish requests",
          count: (t == null ? void 0 : t.incoming) || 0,
          status: b.SUCCESS
        }
      )
    }), (t == null ? void 0 : t.outgoing) > 0 && i.push({
      value: "outgoing",
      title: /* @__PURE__ */ s.jsx(
        se,
        {
          title: "My submissions",
          count: (t == null ? void 0 : t.outgoing) || 0,
          status: b.SUCCESS
        }
      )
      // path: `outgoing`,
    }), a && i.push({
      value: "custom-features",
      title: /* @__PURE__ */ s.jsx(
        se,
        {
          title: "Custom Features",
          count: n ?? (t == null ? void 0 : t.customFeatures) ?? (t == null ? void 0 : t.featureAnalyses) ?? (t == null ? void 0 : t.feature_analyses) ?? 0,
          status: b.SUCCESS
        }
      )
    }), i;
  }
}, Sn = {
  rowId: "id",
  loadingMessage: "Loading...",
  addButtonTitle: null,
  tableTitle: "Artifacts library",
  importButtonTitle: "Import",
  listInitialSort: { id: "modified.timestamp", desc: !0 },
  createSortingMethod: (e) => Nt(e, {
    getSorting: Bt
  }),
  createCrudMethod: (e, t) => Ft(
    e,
    t,
    Ze,
    (n) => Promise.resolve()
  ),
  createFiltersPanel: (e, t) => wt(e, t, qt),
  metadataFilter: `&filter.metadata.subject=${h.COHORT}&filter.metadata.subject=${h.CONCEPT_SET}`,
  extendedSearchEnabled: !0,
  extendedSearchOptions: ["basic", "meta"],
  getCols: ({ metaAttributes: e = [] }) => [
    dt({
      id: "typeIcon",
      cell: he,
      accessorFn: (t) => N[t.type].iconName
    }),
    mt({
      size: 300,
      cell: (t) => {
        var n, a, i, c, u, g, d, l;
        return /* @__PURE__ */ s.jsx(
          _t,
          {
            text: /* @__PURE__ */ s.jsxs("div", { children: [
              /* @__PURE__ */ s.jsx("strong", { children: (a = (n = t.row) == null ? void 0 : n.original) == null ? void 0 : a.name }),
              /* @__PURE__ */ s.jsx("br", {}),
              (c = (i = t.row) == null ? void 0 : i.original) != null && c.description ? (g = (u = t.row) == null ? void 0 : u.original) == null ? void 0 : g.description : ""
            ] }),
            color: "primary",
            width: "auto",
            children: /* @__PURE__ */ s.jsx(
              jt,
              {
                sx: {
                  overflowX: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis"
                },
                children: /* @__PURE__ */ s.jsx(be, { value: (l = (d = t.row) == null ? void 0 : d.original) == null ? void 0 : l.name })
              }
            )
          }
        );
      }
    }),
    {
      header: "Type",
      accessorFn: (t) => {
        var n;
        return ((n = N[t.type]) == null ? void 0 : n.name) || "-";
      },
      id: "type",
      isCropped: !0,
      size: 140,
      minSize: 140,
      maxSize: 140,
      enableResizing: !1,
      meta: {
        align: "left",
        skeletonKind: "text"
      }
    },
    ft({
      header: "Published",
      id: "published",
      accessor: "published",
      accessorKey: "published"
    }),
    gt(),
    pt({
      id: "modified.user.name",
      accessor: "modified.user.name",
      size: 160
    }),
    ...Ot(e, !0)
  ]
}, hn = () => {
  const e = $(), t = k(
    K
  );
  return /* @__PURE__ */ s.jsx(
    St,
    {
      isImport: !1,
      isEnableMetadata: !0,
      onRowClick: (n) => {
        const a = n.original;
        a.type === h.CONCEPT_SET && e(`/library/concept-sets/${a.id}`), a.type === h.COHORT && e(`/library/cohorts/${a.id}`), a.type === h.FEATURE_ANALYSIS && e(`/library/feature-analyses/${a.id}`), a.type === h.CUSTOM_CODE && e(`/library/custom-code/${a.id}`);
      },
      moduleConfig: t,
      variant: "no-header",
      listConfig: Sn
    }
  );
}, Pe = 7 * 24 * 60 * 60 * 1e3, bn = {
  "0_this_week": "This week",
  "1_last_week": "Last week",
  "2_more_than_two_weeks_ago": "More than 2 weeks ago"
}, Qe = (e) => {
  const t = new Date(e).getTime();
  if (!Number.isFinite(t))
    return "2_more_than_two_weeks_ago";
  const n = Date.now() - t;
  return n <= Pe ? "0_this_week" : n <= Pe * 2 ? "1_last_week" : "2_more_than_two_weeks_ago";
}, et = (e) => bn[e] || e || "-", Cn = {
  [h.CONCEPT_SET]: "concept-sets",
  [h.COHORT]: "cohorts",
  [h.FEATURE_ANALYSIS]: "custom-features/publish-requests",
  [h.CUSTOM_CODE]: "custom-code"
}, yn = (e) => {
  const t = (e == null ? void 0 : e.subject) || {}, n = t.id || t.uuid || t.referenceId || t.draftFeatureId || t.featureAnalysisId || (e == null ? void 0 : e.subjectId);
  return n ? String(n) : null;
}, tt = (e, t) => {
  const n = Cn[e == null ? void 0 : e.typeEntity], a = yn(e);
  if (!n || !a || !(e != null && e.id))
    return null;
  const i = new URLSearchParams({
    from: "LIBRARY",
    typePublish: t,
    id: String(e.id)
  });
  return e != null && e.status && i.set("status", String(e.status)), `/library/${n}/${encodeURIComponent(
    a
  )}?${i.toString()}`;
}, Le = (e) => {
  var t;
  return ((t = Ke.find((n) => n.value === e)) == null ? void 0 : t.name) || e || "-";
}, En = (e) => {
  var t;
  return ((t = N[e]) == null ? void 0 : t.name) || "-";
}, xn = (e, t, n) => {
  var i, c;
  const a = (i = n == null ? void 0 : n[0]) == null ? void 0 : i.toLowerCase();
  return a ? [(c = e.original.subject) == null ? void 0 : c.name, e.original.message].some(
    (u) => String(u || "").toLowerCase().includes(a)
  ) : !0;
}, ze = {
  entityBreadcrumb: (e) => [
    {
      name: "Artifacts library",
      path: `${e}`
    },
    {
      name: "Publish Request",
      path: `${e}/incoming`
    }
  ],
  createCols: (e, t) => [
    {
      header: "Search",
      id: "search",
      accessorFn: (n) => {
        var a;
        return `${((a = n.subject) == null ? void 0 : a.name) || ""} ${n.message || ""}`;
      },
      filterFn: xn,
      enableSorting: !1,
      enableHiding: !1,
      enableResizing: !1,
      size: 0,
      minSize: 0,
      maxSize: 0,
      meta: {
        filterVariant: "value",
        invisible: !0
      }
    },
    {
      header: "",
      accessorFn: (n) => {
        var a;
        return (a = N[n.typeEntity]) == null ? void 0 : a.iconName;
      },
      id: "typeEntityIcon",
      enableColumnFilter: !1,
      enableSorting: !1,
      enableResizing: !1,
      enableHiding: !1,
      size: 48,
      minSize: 48,
      maxSize: 48,
      cell: (n) => /* @__PURE__ */ s.jsx(
        he,
        {
          ...n,
          value: n.renderValue(),
          size: 26,
          cell: !0
        }
      ),
      meta: {
        columnType: "action",
        skeletonKind: "type-icon"
      }
    },
    {
      header: "Name",
      accessorKey: "subject.name",
      id: "subject.name",
      size: 420,
      minSize: 320,
      maxSize: 1200,
      enableColumnFilter: !1,
      cell: be
    },
    {
      header: "Status",
      accessorKey: "status",
      id: "status",
      size: 120,
      minSize: 120,
      maxSize: 120,
      enableResizing: !1,
      filterFn: "arrIncludesSomeEqual",
      cell: ({ renderValue: n }) => {
        const a = Ye(), i = n();
        return /* @__PURE__ */ s.jsx(
          Be,
          {
            light: !0,
            text: Le(i),
            color: He(i, a),
            align: "center"
          }
        );
      },
      meta: {
        filterOrder: 0,
        renderFilter: Le
      }
    },
    {
      header: "Type",
      accessorFn: (n) => En(n.typeEntity),
      id: "type",
      size: 140,
      minSize: 140,
      maxSize: 140,
      enableResizing: !1,
      filterFn: "arrIncludesSomeEqual",
      meta: {
        filterOrder: 1
      }
    },
    {
      header: "Author",
      accessorKey: "created.user.name",
      id: "created.user.name",
      size: 190,
      minSize: 160,
      maxSize: 240,
      filterFn: "arrIncludesSomeEqual",
      cell: ht,
      meta: {
        filterOrder: 2
      }
    },
    {
      header: "Created",
      accessorKey: "created.timestamp",
      id: "created.timestamp",
      size: 152,
      minSize: 152,
      maxSize: 152,
      enableColumnFilter: !1,
      enableResizing: !1,
      cell: Ge
    },
    {
      header: "Created",
      accessorFn: (n) => {
        var a;
        return Qe((a = n.created) == null ? void 0 : a.timestamp);
      },
      id: "created.filter",
      size: 0,
      minSize: 0,
      maxSize: 0,
      enableSorting: !1,
      enableHiding: !1,
      enableResizing: !1,
      filterFn: "arrIncludesSomeEqual",
      meta: {
        filterOrder: 3,
        invisible: !0,
        renderFilter: et
      }
    },
    {
      header: "Message",
      accessorKey: "message",
      id: "message",
      size: 220,
      minSize: 180,
      maxSize: 320,
      enableColumnFilter: !1
    },
    {
      header: "",
      accessorKey: "id",
      id: "actions",
      enableColumnFilter: !1,
      enableSorting: !1,
      enableResizing: !1,
      enableHiding: !1,
      size: 180,
      minSize: 180,
      maxSize: 180,
      cell: (n) => {
        const a = n.row.original;
        return /* @__PURE__ */ s.jsx(j, { textAlign: "right", children: /* @__PURE__ */ s.jsx(
          xe,
          {
            type: "INCOMING",
            typeEntity: a.typeEntity,
            name: a.subject.name,
            id: n.renderValue(),
            accept: e,
            dismiss: t,
            textAccept: "Accept",
            textDismiss: "Reject"
          }
        ) });
      },
      meta: {
        align: "right",
        columnType: "action",
        skeletonAlign: "right"
      }
    }
  ]
}, In = (e) => {
  var n;
  let t = "Oops! Something went wrong";
  return ((n = e == null ? void 0 : e.response) == null ? void 0 : n.status) === 500 && (t = e == null ? void 0 : e.message), t;
}, Tn = ({ setSummary: e }) => {
  const { enqueueSnackbar: t } = ie(), n = $(), a = Je(), { path: i } = k(
    K
  ), {
    list: c,
    status: u,
    error: g,
    notifyMessage: d,
    acceptInvitation: l,
    dismissInvitation: p
  } = Ee(W.INCOMING);
  F(() => {
    a(Ve(ze.entityBreadcrumb(i)));
  }, [i]);
  const m = re(() => ze.createCols(l, p), []);
  return F(() => {
    u === b.ERROR && t({
      message: In(g),
      variant: "error"
    }), (u === D.ACCEPT_SUCCESS || u === D.DISMISS_SUCCESS) && (ye().then((S) => e(S)), t({
      message: d,
      variant: "success"
    }));
  }, [u, g]), /* @__PURE__ */ s.jsx(
    j,
    {
      container: !0,
      px: 6,
      py: 2,
      sx: { backgroundColor: "common.white", minHeight: "100%" },
      children: /* @__PURE__ */ s.jsx(j, { item: !0, xs: 12, children: /* @__PURE__ */ s.jsx(
        qe,
        {
          showFilterToggle: !0,
          filtersDefaultClosed: !0,
          enableFiltering: !0,
          pinnedColumns: { right: ["actions"] },
          columns: m,
          data: c,
          loadingMessage: "Loading...",
          loading: u === b.IN_PROGRESS || u === b.INITIAL,
          noDataText: "No data currently available",
          onRowClick: (S) => {
            const o = tt(
              S.original,
              "INCOMING"
            );
            o && n(o);
          },
          defaultSorting: { id: "created.timestamp", desc: !0 }
        }
      ) })
    }
  );
}, Me = (e) => {
  var t;
  return ((t = Ke.find((n) => n.value === e)) == null ? void 0 : t.name) || e || "-";
}, Rn = (e) => {
  var t;
  return ((t = N[e]) == null ? void 0 : t.name) || "-";
}, _n = (e, t, n) => {
  var i, c;
  const a = (i = n == null ? void 0 : n[0]) == null ? void 0 : i.toLowerCase();
  return a ? [(c = e.original.subject) == null ? void 0 : c.name, e.original.message].some(
    (u) => String(u || "").toLowerCase().includes(a)
  ) : !0;
}, ke = {
  entityBreadcrumb: (e) => [
    {
      name: "Artifacts library",
      path: `${e}`
    },
    {
      name: "My submissions",
      path: `${e}/outgoing`
    }
  ],
  createCols: (e) => [
    {
      header: "Search",
      id: "search",
      accessorFn: (t) => {
        var n;
        return `${((n = t.subject) == null ? void 0 : n.name) || ""} ${t.message || ""}`;
      },
      filterFn: _n,
      enableSorting: !1,
      enableHiding: !1,
      enableResizing: !1,
      size: 0,
      minSize: 0,
      maxSize: 0,
      meta: {
        filterVariant: "value",
        invisible: !0
      }
    },
    {
      header: "",
      accessorFn: (t) => {
        var n;
        return (n = N[t.typeEntity]) == null ? void 0 : n.iconName;
      },
      id: "typeEntityIcon",
      enableColumnFilter: !1,
      enableSorting: !1,
      enableResizing: !1,
      enableHiding: !1,
      size: 48,
      minSize: 48,
      maxSize: 48,
      cell: (t) => /* @__PURE__ */ s.jsx(
        he,
        {
          ...t,
          value: t.renderValue(),
          size: 26,
          cell: !0
        }
      ),
      meta: {
        columnType: "action",
        skeletonKind: "type-icon"
      }
    },
    {
      header: "Name",
      accessorKey: "subject.name",
      id: "subject.name",
      size: 420,
      minSize: 320,
      maxSize: 1200,
      enableColumnFilter: !1,
      cell: be
    },
    {
      header: "Type",
      accessorFn: (t) => Rn(t.typeEntity),
      id: "type",
      size: 140,
      minSize: 140,
      maxSize: 140,
      enableResizing: !1,
      filterFn: "arrIncludesSomeEqual",
      meta: {
        filterOrder: 1
      }
    },
    {
      header: "Created",
      accessorKey: "created.timestamp",
      id: "created.timestamp",
      size: 152,
      minSize: 152,
      maxSize: 152,
      enableColumnFilter: !1,
      enableResizing: !1,
      cell: Ge
    },
    {
      header: "Created",
      accessorFn: (t) => {
        var n;
        return Qe((n = t.created) == null ? void 0 : n.timestamp);
      },
      id: "created.filter",
      size: 0,
      minSize: 0,
      maxSize: 0,
      enableSorting: !1,
      enableHiding: !1,
      enableResizing: !1,
      filterFn: "arrIncludesSomeEqual",
      meta: {
        filterOrder: 2,
        invisible: !0,
        renderFilter: et
      }
    },
    {
      header: "Request Message",
      accessorKey: "message",
      id: "message",
      size: 260,
      minSize: 220,
      maxSize: 420,
      enableColumnFilter: !1
    },
    {
      header: "Status",
      accessorKey: "status",
      id: "status",
      cell: ({ renderValue: t }) => {
        const n = Ye(), a = t();
        return /* @__PURE__ */ s.jsx(
          Be,
          {
            light: !0,
            text: Me(a),
            color: He(a, n),
            align: "center"
          }
        );
      },
      size: 120,
      minSize: 120,
      maxSize: 120,
      enableResizing: !1,
      filterFn: "arrIncludesSomeEqual",
      meta: {
        filterOrder: 0,
        renderFilter: Me
      }
    },
    {
      header: "",
      accessorKey: "id",
      id: "actions",
      enableColumnFilter: !1,
      enableSorting: !1,
      enableResizing: !1,
      enableHiding: !1,
      size: 120,
      minSize: 120,
      maxSize: 120,
      cell: (t) => {
        const n = t.row.original;
        return /* @__PURE__ */ s.jsx(j, { textAlign: "right", children: n.status === We.PENDING ? /* @__PURE__ */ s.jsx(
          xe,
          {
            type: "OUTGOING",
            typeEntity: n.typeEntity,
            name: t.row.original.subject.name,
            id: t.renderValue(),
            dismiss: e,
            textDismiss: "Cancel"
          }
        ) : /* @__PURE__ */ s.jsx(s.Fragment, {}) });
      },
      meta: {
        align: "right",
        columnType: "action",
        skeletonAlign: "right"
      }
    }
  ]
}, jn = ({ setSummary: e }) => {
  const { enqueueSnackbar: t } = ie(), n = Je(), a = $(), { path: i } = k(
    K
  ), { list: c, status: u, dismissInvitation: g, error: d, notifyMessage: l } = Ee(W.OUTGOING);
  F(() => {
    n(Ve(ke.entityBreadcrumb(i)));
  }, [i]);
  const p = re(() => ke.createCols(g), []);
  return F(() => {
    u === b.ERROR && t({
      message: Pt(d),
      variant: "error"
    }), (u === D.ACCEPT_SUCCESS || u === D.DISMISS_SUCCESS) && (ye().then((m) => e(m)), t({
      message: l,
      variant: "success"
    }));
  }, [u, d]), /* @__PURE__ */ s.jsx(
    j,
    {
      container: !0,
      px: 6,
      py: 2,
      sx: { backgroundColor: "common.white", minHeight: "100%" },
      children: /* @__PURE__ */ s.jsx(j, { item: !0, xs: 12, children: /* @__PURE__ */ s.jsx(
        qe,
        {
          showFilterToggle: !0,
          filtersDefaultClosed: !0,
          enableFiltering: !0,
          pinnedColumns: { right: ["actions"] },
          columns: p,
          data: c,
          loadingMessage: "Loading...",
          loading: u === b.IN_PROGRESS || u === b.INITIAL,
          noDataText: "No data currently available",
          onRowClick: (m) => {
            const S = tt(
              m.original,
              "OUTGOING"
            );
            S && a(S);
          },
          defaultSorting: { id: "created.timestamp", desc: !0 }
        }
      ) })
    }
  );
}, vn = (e) => {
  const { children: t, tabs: n } = e, { subModules: a } = k(
    K
  ), i = re(() => a == null ? void 0 : a.customCode, [a == null ? void 0 : a.customCode]);
  return /* @__PURE__ */ s.jsxs(bt, { children: [
    /* @__PURE__ */ s.jsxs(Ct, { children: [
      /* @__PURE__ */ s.jsx(
        yt,
        {
          title: "Artifacts library",
          iconName: "library",
          customButtons: /* @__PURE__ */ s.jsx(
            i,
            {
              type: "component",
              name: "publish-custom-code",
              subModules: a,
              config: {}
            }
          )
        }
      ),
      /* @__PURE__ */ s.jsx(Et, { tabs: n, withRouting: !0 })
    ] }),
    /* @__PURE__ */ s.jsx(xt, { children: t })
  ] });
}, De = "prometheus:custom-features-changed", nt = (e) => e.startsWith("/library/custom-features"), An = (e) => e.replace(/\/+$/, "") === "/library/custom-features", Nn = (e) => e === "/library/incoming" || nt(e), On = () => {
  let e = ot();
  const t = $(), { subModules: n, path: a, initStorage: i, storage: c, rootSettings: u } = k(
    K
  ), [g, d] = P(), [l, p] = P(), [m, S] = P(
    () => nt(e.pathname)
  ), o = It(), E = ae.useRef(e.pathname), { entityNavigationPanel: x } = pn, A = ae.useCallback(() => {
    we().then((T) => {
      p(T), S(!0);
    }).catch((T) => {
      var v;
      p(0), [401, 403].includes((v = T == null ? void 0 : T.response) == null ? void 0 : v.status) && S(!1);
    });
  }, []), U = ae.useCallback((T) => {
    p(T), S(!0);
  }, []);
  F(() => {
    let T = !0;
    return ye().then((v) => {
      T && d(v);
    }), An(E.current) || we().then((v) => {
      T && (p(v), S(!0));
    }).catch((v) => {
      var Y;
      T && (p(0), [401, 403].includes((Y = v == null ? void 0 : v.response) == null ? void 0 : Y.status) && S(!1));
    }), () => {
      T = !1;
    };
  }, []), F(() => {
    l !== void 0 && !m && Nn(e.pathname) && t("/library", { replace: !0 });
  }, [
    l,
    m,
    e.pathname,
    t
  ]), F(() => (window.addEventListener(
    De,
    A
  ), () => {
    window.removeEventListener(
      De,
      A
    );
  }), [A]);
  const G = re(() => x(
    m && o,
    g,
    l,
    m
  ), [l, m, o, g]);
  return /* @__PURE__ */ s.jsx(vn, { tabs: G, children: /* @__PURE__ */ s.jsx(j, { item: !0, xs: 12, children: /* @__PURE__ */ s.jsxs($e, { children: [
    /* @__PURE__ */ s.jsx(w, { index: !0, element: /* @__PURE__ */ s.jsx(hn, {}) }),
    m && /* @__PURE__ */ s.jsx(
      w,
      {
        path: "incoming",
        element: /* @__PURE__ */ s.jsx(Tn, { setSummary: d })
      }
    ),
    /* @__PURE__ */ s.jsx(
      w,
      {
        path: "outgoing",
        element: /* @__PURE__ */ s.jsx(jn, { setSummary: d })
      }
    ),
    m && /* @__PURE__ */ s.jsx(
      w,
      {
        path: "custom-features/*",
        element: /* @__PURE__ */ s.jsx(
          n.featureanalyses,
          {
            name: "custom-features",
            iconName: "feature-analyses",
            path: `${a}/custom-features`,
            title: "Custom Features",
            subModules: n,
            initStorage: i,
            storage: c,
            rootSettings: u,
            isMainMenu: !1,
            config: {
              typeContainer: H.LIBRARY,
              parentId: null,
              featureEntitySource: "draft",
              onCustomFeaturesCountChange: U
            }
          }
        )
      }
    ),
    /* @__PURE__ */ s.jsx(
      w,
      {
        path: "feature-analyses/*",
        element: /* @__PURE__ */ s.jsx(
          n.featureanalyses,
          {
            name: "feature-analyses",
            iconName: "feature-analyses",
            path: `${a}/feature-analyses`,
            title: "Feature analyses",
            subModules: n,
            initStorage: i,
            storage: c,
            rootSettings: u,
            isMainMenu: !1,
            config: {
              typeContainer: H.LIBRARY,
              parentId: null,
              featureEntitySource: "published"
            }
          }
        )
      }
    )
  ] }) }) });
}, K = it(null), wn = (e) => {
  const {
    path: t,
    title: n,
    name: a,
    storage: i,
    initStorage: c,
    rootSettings: u,
    subModules: g,
    config: d
  } = e, [l, p] = P(u), [m, S] = P(!0);
  return F(() => {
    u || p({
      rootPath: t,
      rootTitle: n
    }), S(!1), document.title = "Prometheus - Library";
  }, []), m ? /* @__PURE__ */ s.jsx(Ue, { children: /* @__PURE__ */ s.jsx(Ce, { size: 32 }) }) : /* @__PURE__ */ s.jsx(K.Provider, { value: { ...e, rootSettings: l }, children: /* @__PURE__ */ s.jsxs($e, { children: [
    /* @__PURE__ */ s.jsx(
      w,
      {
        path: "cohorts/*",
        element: /* @__PURE__ */ s.jsx(
          g.cohort,
          {
            name: "cohorts",
            iconName: "cohorts",
            path: `${t}/cohorts`,
            title: "Cohorts",
            subModules: g,
            initStorage: c,
            storage: i,
            rootSettings: l,
            isMainMenu: !1,
            config: {
              typeContainer: H.LIBRARY,
              parentId: null
            }
          }
        )
      }
    ),
    /* @__PURE__ */ s.jsx(
      w,
      {
        path: "concept-sets/*",
        element: /* @__PURE__ */ s.jsx(
          g.concept,
          {
            name: "concept-sets",
            iconName: "concept-sets",
            path: `${t}/concept-sets`,
            title: "Concept sets",
            subModules: g,
            initStorage: c,
            storage: i,
            rootSettings: l,
            isMainMenu: !1,
            config: {
              typeContainer: H.LIBRARY,
              parentId: null
            }
          }
        )
      }
    ),
    /* @__PURE__ */ s.jsx(
      w,
      {
        path: "custom-code/*",
        element: /* @__PURE__ */ s.jsx(
          g.customCode,
          {
            name: "custom-code",
            iconName: "feature-analyses",
            path: `${t}/custom-code`,
            title: "Custom code",
            subModules: g,
            initStorage: c,
            storage: i,
            rootSettings: l,
            isMainMenu: !1,
            config: {
              typeContainer: H.LIBRARY,
              parentId: null
            }
          }
        )
      }
    ),
    /* @__PURE__ */ s.jsx(
      w,
      {
        path: "custom-features/publish-requests/*",
        element: /* @__PURE__ */ s.jsx(
          g.featureanalyses,
          {
            name: "custom-features-publish-request",
            iconName: "feature-analyses",
            path: `${t}/custom-features/publish-requests`,
            title: "Custom Features",
            subModules: g,
            initStorage: c,
            storage: i,
            rootSettings: l,
            isMainMenu: !1,
            config: {
              typeContainer: H.LIBRARY,
              parentId: null,
              featureEntitySource: "draft",
              publishRequestPreview: !0
            }
          }
        )
      }
    ),
    /* @__PURE__ */ s.jsx(w, { path: "/*", element: /* @__PURE__ */ s.jsx(On, {}) })
  ] }) });
}, Yn = (e) => {
  const { type: t } = e;
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    !t && /* @__PURE__ */ s.jsx(wn, { ...e }),
    t === "component" && /* @__PURE__ */ s.jsx(gn, { ...e })
  ] });
};
export {
  Yn as Library
};
//# sourceMappingURL=library.js.map
